// P5-2: 埋点上报薄壳。
//
// 设计要点：
// - 主路径 fetch + keepalive=true：tab 关闭 / 路由切换时仍然能把请求发出去，
//   且支持 Authorization Bearer 头（navigator.sendBeacon 不允许自定义头，
//   而本仓库 JWT 在 localStorage 不在 cookie 里，所以不能用 sendBeacon）。
// - 失败兜底：在 hook 层做"内存队列重试 1 次即丢"，这里只暴露原子 POST。
// - 不走 axios client：axios 拦截器在 unload 期间不可靠；analytics 是 best-effort，
//   不要被 401 refresh 拦截链卷进重试 dance。
// - URL 与后端 EventTrackingView 路由一致：POST /api/analytics/events/

const ENDPOINT = `${process.env.REACT_APP_API_BASE_URL || '/api'}/analytics/events/`;

export function postEvent(payload) {
  const token = localStorage.getItem('access_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  return fetch(ENDPOINT, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
    keepalive: true,
    credentials: 'omit',
  });
}
